<template>
  <v-card id="product-image-dialog">
    <template>
      <v-card-title class="i-dialog-header-div">
        <span class="g-heading-m g-bold">Image Specifications</span>
      </v-card-title>

      <v-card-text class="p-image-example-dialog-text py-4">
        <p class="g-bold g-heading-xs mt-3 mb-2">
          IMAGE REQUIREMENTS FOR BEST RESULTS IN RETAILER MARKETPLACE
        </p>
        <div>
          <ul>
            <li>Max. file size: <strong>1MB</strong></li>
            <li>
              JPEG (.JPEG/.JPG), PNG (.PNG), WEBP (.WEBP), OR AVIF (.AVIF)
              format
            </li>
            <li>
              <strong>1:1 square</strong> size with dimensions
              <strong>1000px X 1000px</strong>
            </li>
            <li>
              Pure white background (Not transparent), e.g. RGB (255, 255, 255)
            </li>
            <li>
              Full product fills <strong>85%</strong> of the frame with minimal
              white background to maximise the image size. See example below:
              <ul>
                <li>the green frame is the image boundary</li>
                <li>the blue frame represents 85%</li>
              </ul>
            </li>
          </ul>
        </div>

        <p class="g-bold g-heading-xs mt-3 mb-2">ADDITIONAL INFORMATION</p>
        <div>
          <ul>
            <li>
              The image must be a professional photograph or covert art of the
              product being sold
            </li>
            <li>The image needs to be in-focus and professionally lit</li>
            <li>
              The image needs to contain realistic colours and look like the
              product being sold
            </li>
            <li>
              The image can't contain additional objects that are confusing
            </li>
            <li>The image can't contain unnecessary graphics or text</li>
            <li>
              The image must have smooth edges, as opposed to jagged edges
            </li>
            <li>
              The image must not include badges such as "Best Seller" or "Top
              Seller"
            </li>
            <li>
              The image can't feature any sort of designs, including watermarks,
              on the images
            </li>
          </ul>
        </div>

        <p class="g-bold g-heading-xs mt-6 mb-2">EXAMPLE IMAGE</p>
        <div>
          <v-img contain src="@/assets/flewid-product-example.jpg"> </v-img>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="i-dialog-actions-div">
        <v-spacer></v-spacer>
        <v-btn
          text
          rounded
          class="i-btn-text-secondary mr-2"
          @click="handleClose"
        >
          Close
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
export default {
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

#product-image-dialog {
  background: white;
  .v-card__title,
  .v-card__text,
  .v-card__actions {
    background: white;
  }
  .p-image-example-dialog {
    &-text {
      height: 600px;
      overflow-y: auto;
    }
    .p-section-title {
      color: $secondary-color;
    }
  }
}
</style>
